var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "containerInfo" },
    [
      _c(
        "el-row",
        { staticClass: "margin mb-20", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 6 } },
            [
              _c("app-label", { attrs: { label: "CNUC", required: true } }),
              _c("el-input", {
                staticClass: "input",
                attrs: { type: "text", placeholder: "Digite o CNUC" },
                model: {
                  value: _vm.informacoesAdministrativas.cnuc,
                  callback: function($$v) {
                    _vm.$set(_vm.informacoesAdministrativas, "cnuc", $$v)
                  },
                  expression: "informacoesAdministrativas.cnuc"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: {
                  label: "Nome da Unidade de Conservação",
                  required: true
                }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: {
                  type: "text",
                  placeholder: "Digite o nome da unidade de conservação"
                },
                model: {
                  value: _vm.informacoesAdministrativas.nomeUc,
                  callback: function($$v) {
                    _vm.$set(_vm.informacoesAdministrativas, "nomeUc", $$v)
                  },
                  expression: "informacoesAdministrativas.nomeUc"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Esfera Administrativa", required: true }
              }),
              _c(
                "el-select",
                {
                  staticClass: "full-width",
                  attrs: { placeholder: "Selecione a esfera administrativa" },
                  model: {
                    value: _vm.informacoesAdministrativas.esferaAdministrativa,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.informacoesAdministrativas,
                        "esferaAdministrativa",
                        $$v
                      )
                    },
                    expression:
                      "informacoesAdministrativas.esferaAdministrativa"
                  }
                },
                _vm._l(_vm.optionsEsfera, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 24 } },
            [
              _c("app-label", {
                attrs: { label: "Objetivo da Criação da UC", required: true }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: {
                  type: "textarea",
                  placeholder: "Digite o objetivo (até 2000 caracteres)",
                  rows: "4"
                },
                model: {
                  value: _vm.informacoesAdministrativas.objetivoCriacaoUc,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.informacoesAdministrativas,
                      "objetivoCriacaoUc",
                      $$v
                    )
                  },
                  expression: "informacoesAdministrativas.objetivoCriacaoUc"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 6 } },
            [
              _c("app-label", {
                attrs: { label: "Órgão Gestor", required: true }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: { type: "text", placeholder: "Digite o órgão gestor" },
                model: {
                  value: _vm.informacoesAdministrativas.orgaoGestor,
                  callback: function($$v) {
                    _vm.$set(_vm.informacoesAdministrativas, "orgaoGestor", $$v)
                  },
                  expression: "informacoesAdministrativas.orgaoGestor"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 24 } },
            [
              _c("app-label", {
                attrs: { label: "Categoria de Manejo", required: true }
              }),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.informacoesAdministrativas.tipoUc,
                    callback: function($$v) {
                      _vm.$set(_vm.informacoesAdministrativas, "tipoUc", $$v)
                    },
                    expression: "informacoesAdministrativas.tipoUc"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "ProtecaoIntegral" } }, [
                    _vm._v("UCs de proteção integral")
                  ]),
                  _c("el-radio", { attrs: { label: "UsoSustentavel" } }, [
                    _vm._v("UCs de uso sustentável")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.informacoesAdministrativas.tipoUc === "ProtecaoIntegral"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Tipo de UC de Proteção Integral",
                      required: true
                    }
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: {
                        placeholder:
                          "Selecione o tipo de UC de proteção integral"
                      },
                      model: {
                        value:
                          _vm.informacoesAdministrativas.tipoUcProtecaoIntegral,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.informacoesAdministrativas,
                            "tipoUcProtecaoIntegral",
                            $$v
                          )
                        },
                        expression:
                          "informacoesAdministrativas.tipoUcProtecaoIntegral"
                      }
                    },
                    _vm._l(_vm.optionsProtecaoIntegral, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.informacoesAdministrativas.tipoUc === "UsoSustentavel"
        ? _c(
            "el-row",
            { staticClass: "margin mb-20", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Tipo de UC de Uso Sustentável",
                      required: true
                    }
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: {
                        placeholder: "Selecione o tipo de UC de uso sustentável"
                      },
                      model: {
                        value:
                          _vm.informacoesAdministrativas.tipoUcUsoSustentavel,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.informacoesAdministrativas,
                            "tipoUcUsoSustentavel",
                            $$v
                          )
                        },
                        expression:
                          "informacoesAdministrativas.tipoUcUsoSustentavel"
                      }
                    },
                    _vm._l(_vm.optionsUsoSustentavel, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0cec204", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0cec204","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppFormularioInformacoesAdministrativas.vue
// module id = null
// module chunks = 